module.exports = __webpack_public_path__ + "img/伯才公众号_副本.d6145a8b.png";